const CommonRequest = function() {
  this.MemberId = null;
  this.ReservationId = null;
};
export default CommonRequest;
